module.exports = __webpack_public_path__ + "static/img/icon-11.590f30eb.png";